import { gql } from 'graphql-request';
import { TaxonomySummary, Sample, Marker, ChartIds } from 'src/shared/types';

export const communityComparisonChartDataQuery = gql`
    query getCommunityComparisonChartData($projectId: String!, $fromDate: String, $toDate: String, $habitatAssay: String!) {
        communityComparisonChartData: chart(
            projectId: $projectId
            chartId: "${ChartIds.COMMUNITY_COMPARISON}"
            habitatAssay: $habitatAssay
            fromDate: $fromDate
            toDate: $toDate
        ) {
            data
        }
    }
`;

export type SingleYearCommunityComparisonData = {
    variable: {
        key: string;
        value: string;
    };
    comparisons: {
        comparedTo: string;
        sig_diff: boolean;
        p_value: number;
    }[];
    points: {
        sampleId: string;
        coordinates: number[];
    }[];
    polys: {
        order: number;
        coordinates: number[];
    }[];
};

type CommunityComparisonChartData = {
    data: {
        years: {
            data: SingleYearCommunityComparisonData[];
            samplingYear: string;
        }[];
        metric: null;
    }[];
};

export type CommunityComparisonChartDataQueryResult = {
    communityComparisonChartData: CommunityComparisonChartData;
};

export const communityComparisonSamplesQuery = gql`
    query getSamples($projectId: String!, $samples: sampleFilter) {
        communityComparisonSamples: project(projectId: $projectId, samples: $samples) {
            taxonomySummary {
                taxonomy {
                    tax_species
                }
                assayId
                conservationStatus {
                    iucnRedListStatus
                    chegdCommonName
                    chegdGroup
                    onGRIISList
                }
                sampleCount
                percentTotalSamples
                samples
            }
            samples {
                sampleId
                sampleReceivedDate
                location {
                    coordinates
                    type
                }
                assays {
                    assayId
                    assayName
                    numberNamedSpecies
                }
                covariates
                metrics
            }
        }
    }
`;

type CommunityComparisonSamples = {
    taxonomySummary: Omit<TaxonomySummary, 'taxonomy'> & {
        taxonomy: {
            tax_class: string;
        }[];
    };
    samples: Sample[];
};

export type CommunityComparisonSamplesQueryResult = {
    communityComparisonSamples: CommunityComparisonSamples;
};

export const markersQuery = gql`
    query markers($projectId: String!, $sampleId: String!) {
        markers(projectId: $projectId, sampleId: $sampleId) {
            assayId
            numberNamedSpecies
            results {
                taxonomy {
                    tax_species
                }
            }
            metrics
        }
    }
`;

type MarkersData = Pick<Marker, 'assayId' | 'numberNamedSpecies' | 'results' | 'metrics'>[];

export type MarkersQueryResult = {
    markers: MarkersData;
};
